var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Metaplex, walletAdapterIdentity } from "@metaplex-foundation/js";
import { AnchorProvider, Program } from "@coral-xyz/anchor";
import * as anchor from "@coral-xyz/anchor";
import { PublicKey, Keypair, SystemProgram, ComputeBudgetProgram, } from "@solana/web3.js";
import { IDL } from "./types/impact_nft.js";
import { ASSOCIATED_TOKEN_PROGRAM_ID, getAssociatedTokenAddressSync, TOKEN_PROGRAM_ID, } from "@solana/spl-token";
var TOKEN_METADATA_PROGRAM_ID = new PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s");
export var PROGRAM_ID = new PublicKey("SUNFT6ErsQvMcDzMcGyndq2P31wYCFs6G6WEcoyGkGc");
export var confirm = function (connection) { return function (txSig) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _b = (_a = connection).confirmTransaction;
                _c = [{ signature: txSig }];
                return [4 /*yield*/, connection.getLatestBlockhash()];
            case 1: return [2 /*return*/, _b.apply(_a, [__assign.apply(void 0, _c.concat([(_d.sent())]))])];
        }
    });
}); }; };
export var setUpAnchor = function () {
    // Configure the client to use the local cluster.
    var provider = AnchorProvider.env();
    anchor.setProvider(provider);
    return provider;
};
var getOffsetTiersAddress = function (stateAddress) {
    return PublicKey.findProgramAddressSync([Buffer.from("offset_tiers"), stateAddress.toBuffer()], PROGRAM_ID)[0];
};
var ImpactNftClient = /** @class */ (function () {
    function ImpactNftClient(provider) {
        this.provider = provider;
        this.program = new Program(IDL, PROGRAM_ID, provider);
        this.metaplex = Metaplex.make(provider.connection).use(walletAdapterIdentity(provider.wallet));
    }
    ImpactNftClient.register = function (adminMintAuthority, levels, fee) {
        return __awaiter(this, void 0, void 0, function () {
            var client, stateKey, tokenAuthority, accounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        client = new ImpactNftClient(setUpAnchor());
                        stateKey = Keypair.generate();
                        tokenAuthority = client.getTokenAuthorityAddress(stateKey.publicKey);
                        accounts = {
                            payer: client.provider.publicKey,
                            adminUpdateAuthority: client.provider.publicKey,
                            globalState: stateKey.publicKey,
                            tokenAuthority: tokenAuthority,
                            systemProgram: SystemProgram.programId,
                        };
                        return [4 /*yield*/, client.program.methods
                                .createGlobalState({
                                adminMintAuthority: adminMintAuthority,
                                levels: levels,
                                fee: fee || null,
                            })
                                .accounts(accounts)
                                .signers([stateKey])
                                .rpc()
                                .then(function () { return confirm(client.provider.connection); })];
                    case 1:
                        _a.sent();
                        console.log("Created global state", stateKey.publicKey.toBase58());
                        console.log("initialising...");
                        return [4 /*yield*/, client.init(stateKey.publicKey)];
                    case 2:
                        _a.sent();
                        console.log("initialised");
                        return [2 /*return*/, client];
                }
            });
        });
    };
    ImpactNftClient.get = function (provider, stateAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        client = new ImpactNftClient(provider);
                        return [4 /*yield*/, client.init(stateAddress)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, client];
                }
            });
        });
    };
    ImpactNftClient.prototype.init = function (stateAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, tiersAddress, _b, tokenAuthority;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.stateAddress = stateAddress;
                        _a = this;
                        return [4 /*yield*/, this.program.account.globalState.fetch(stateAddress)];
                    case 1:
                        _a.state = _c.sent();
                        tiersAddress = this.getOffsetTiersAddress();
                        _b = this;
                        return [4 /*yield*/, this.program.account.offsetTiers.fetchNullable(tiersAddress)];
                    case 2:
                        _b.tiers = _c.sent();
                        tokenAuthority = this.getTokenAuthorityAddress(stateAddress);
                        this.config = {
                            mintAuthority: this.state.adminMintAuthority,
                            updateAuthority: this.state.adminUpdateAuthority,
                            tokenAuthority: tokenAuthority,
                            levels: this.state.levels,
                            fee: this.state.fee,
                        };
                        return [2 /*return*/];
                }
            });
        });
    };
    ImpactNftClient.prototype.details = function () {
        if (!this.state)
            throw new Error("not initialized");
        return {
            state: this.state,
            levels: this.levels,
        };
    };
    ImpactNftClient.prototype.getTokenAuthorityAddress = function (state) {
        return PublicKey.findProgramAddressSync([Buffer.from("token_authority"), state.toBuffer()], PROGRAM_ID)[0];
    };
    ImpactNftClient.prototype.getOffsetTiersAddress = function () {
        if (!this.stateAddress)
            throw new Error("Client not initialized");
        return getOffsetTiersAddress(this.stateAddress);
    };
    ImpactNftClient.prototype.getOffsetMetadataAddress = function (mint) {
        if (!this.stateAddress)
            throw new Error("Client not initialized");
        return PublicKey.findProgramAddressSync([
            Buffer.from("offset_metadata"),
            mint.toBuffer(),
            this.stateAddress.toBuffer(),
        ], PROGRAM_ID)[0];
    };
    /** get metadata account... can't find an easy way to do this via their sdk */
    ImpactNftClient.prototype.getMetadataAddress = function (mint) {
        return PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            TOKEN_METADATA_PROGRAM_ID.toBuffer(),
            mint.toBuffer(),
        ], TOKEN_METADATA_PROGRAM_ID)[0];
    };
    /** get master edition account... can't find an easy way to do this via their sdk */
    ImpactNftClient.prototype.getMasterEditionAddress = function (mint) {
        return PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            TOKEN_METADATA_PROGRAM_ID.toBuffer(),
            mint.toBuffer(),
            Buffer.from("edition"),
        ], TOKEN_METADATA_PROGRAM_ID)[0];
    };
    ImpactNftClient.prototype.createCollectionMint = function (uri, name) {
        return __awaiter(this, void 0, void 0, function () {
            var mint, nft;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.config)
                            throw new Error("Client not initialized");
                        mint = Keypair.generate();
                        return [4 /*yield*/, this.metaplex.nfts().create({
                                uri: uri,
                                name: name,
                                sellerFeeBasisPoints: 100,
                                useNewMint: mint,
                                isCollection: true,
                            })];
                    case 1:
                        nft = (_a.sent()).nft;
                        return [4 /*yield*/, this.metaplex.nfts().update({
                                nftOrSft: nft,
                                newUpdateAuthority: this.config.tokenAuthority,
                            })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, mint];
                }
            });
        });
    };
    ImpactNftClient.prototype.registerOffsetTiers = function (levels) {
        return __awaiter(this, void 0, void 0, function () {
            var offsetTiersAddress, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.stateAddress)
                            throw new Error("Client not initialized");
                        offsetTiersAddress = this.getOffsetTiersAddress();
                        return [4 /*yield*/, this.program.methods
                                .createOffsetTiers({
                                levels: levels,
                            })
                                .accounts({
                                adminUpdateAuthority: this.provider.publicKey,
                                globalState: this.stateAddress,
                                offsetTiers: offsetTiersAddress,
                                systemProgram: SystemProgram.programId,
                            })
                                .rpc()
                                .then(function () { return confirm(_this.provider.connection); })];
                    case 1:
                        _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.program.account.offsetTiers.fetchNullable(offsetTiersAddress)];
                    case 2:
                        _a.tiers = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ImpactNftClient.prototype.addLevelsToOffsetTiers = function (levels) {
        return __awaiter(this, void 0, void 0, function () {
            var offsetTiersAddress, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.stateAddress)
                            throw new Error("Client not initialized");
                        offsetTiersAddress = this.getOffsetTiersAddress();
                        return [4 /*yield*/, this.program.methods
                                .addLevels(levels)
                                .accounts({
                                adminUpdateAuthority: this.provider.publicKey,
                                globalState: this.stateAddress,
                                offsetTiers: offsetTiersAddress,
                            })
                                .rpc()
                                .then(function () { return confirm(_this.provider.connection); })];
                    case 1:
                        _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.program.account.offsetTiers.fetchNullable(offsetTiersAddress)];
                    case 2:
                        _a.tiers = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ImpactNftClient.prototype.getMintNftAccounts = function (mint, user) {
        return __awaiter(this, void 0, void 0, function () {
            var metadata, masterEdition, offsetMetadata, offsetTiers, userTokenAccount, collectionAccounts, feeAccounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.stateAddress || !this.config)
                            throw new Error("Client not initialized");
                        metadata = this.getMetadataAddress(mint);
                        masterEdition = this.getMasterEditionAddress(mint);
                        offsetMetadata = this.getOffsetMetadataAddress(mint);
                        offsetTiers = this.getOffsetTiersAddress();
                        userTokenAccount = getAssociatedTokenAddressSync(mint, user, true);
                        return [4 /*yield*/, this.getCollectionAccounts()];
                    case 1:
                        collectionAccounts = _a.sent();
                        feeAccounts = this.getFeeAccounts(user);
                        return [2 /*return*/, __assign(__assign({ program: PROGRAM_ID, tokenMetadataProgram: TOKEN_METADATA_PROGRAM_ID, adminMintAuthority: this.config.mintAuthority, tokenAuthority: this.getTokenAuthorityAddress(this.stateAddress), metadata: metadata, userTokenAccount: userTokenAccount, masterEdition: masterEdition, offsetMetadata: offsetMetadata, offsetTiers: offsetTiers }, collectionAccounts), feeAccounts)];
                }
            });
        });
    };
    ImpactNftClient.prototype.getFeeAccounts = function (user) {
        if (!this.config)
            throw new Error("Client not initialized");
        var feeAccounts = {
            payerTokenAccount: null,
            recipient: null,
            recipientTokenAccount: null,
        };
        if (this.config.fee) {
            if (this.config.fee.coinType.hasOwnProperty("spl")) {
                if (!this.config.fee.splTokenMint)
                    throw new Error("No spl token mint provided for fee of type SPL");
                feeAccounts.payerTokenAccount = getAssociatedTokenAddressSync(this.config.fee.splTokenMint, user, true);
                feeAccounts.recipientTokenAccount = getAssociatedTokenAddressSync(this.config.fee.splTokenMint, this.config.fee.recipient, true);
            }
            else {
                feeAccounts.recipient = this.config.fee.recipient;
            }
        }
        return feeAccounts;
    };
    ImpactNftClient.prototype.getLevelForOffset = function (offset) {
        if (!this.tiers)
            throw new Error("Client not initialized");
        // search backwards so we get the highest level
        var level = this.levels
            .reverse()
            .find(function (level, index) { return offset.gte(level.offset); });
        return level || null;
    };
    /*
     * Returns the amount of needed to reach the next offset level
     * If the offset is higher than the highest level, returns null (no more levels)
     */
    ImpactNftClient.prototype.getAmountToNextOffset = function (offset, currentLevel) {
        if (!this.tiers)
            throw new Error("Client not initialized");
        var level = currentLevel !== undefined ? this.levels[currentLevel] : this.getLevelForOffset(offset);
        // if no level was found, the offset is lower than the lowest level
        // so we return the offset of the lowest level ( minus the current offset)
        if (!level)
            return this.levels[0].offset.sub(offset);
        var nextLevel = this.levels[level.index + 1];
        if (!nextLevel)
            return null;
        return nextLevel.offset.sub(offset);
    };
    ImpactNftClient.prototype.getUpdateNftAccounts = function (mint, offset) {
        return __awaiter(this, void 0, void 0, function () {
            var collectionMint, collectionMetadata, collectionMasterEdition, newCollectionMint, newCollectionMetadata, newCollectionMasterEdition;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.stateAddress || !this.config)
                            throw new Error("Client not initialized");
                        return [4 /*yield*/, this.getCurrentCollectionForMint(mint)];
                    case 1:
                        collectionMint = _a.sent();
                        collectionMetadata = this.getMetadataAddress(collectionMint);
                        collectionMasterEdition = this.getMasterEditionAddress(collectionMint);
                        return [4 /*yield*/, this.getUpdateCollectionForOffset(offset)];
                    case 2:
                        newCollectionMint = _a.sent();
                        if (newCollectionMint === null)
                            throw new Error("No levels in offset tiers");
                        newCollectionMetadata = this.getMetadataAddress(newCollectionMint);
                        newCollectionMasterEdition = this.getMasterEditionAddress(newCollectionMint);
                        return [2 /*return*/, {
                                collectionMint: collectionMint,
                                collectionMetadata: collectionMetadata,
                                collectionMasterEdition: collectionMasterEdition,
                                newCollectionMint: newCollectionMint,
                                newCollectionMetadata: newCollectionMetadata,
                                newCollectionMasterEdition: newCollectionMasterEdition,
                                tokenMetadataProgram: TOKEN_METADATA_PROGRAM_ID,
                            }];
                }
            });
        });
    };
    ImpactNftClient.prototype.getCurrentCollectionForMint = function (mint) {
        return __awaiter(this, void 0, void 0, function () {
            var offsetMetadata, index, levels;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.stateAddress || !this.tiers)
                            throw new Error("Client not initialized");
                        offsetMetadata = this.getOffsetMetadataAddress(mint);
                        return [4 /*yield*/, this.program.account.offsetMetadata
                                .fetch(offsetMetadata)
                                .then(function (res) { return res.currentLevelIndex; })];
                    case 1:
                        index = _a.sent();
                        levels = this.tiers.levels;
                        return [2 /*return*/, levels[index].collectionMint];
                }
            });
        });
    };
    // Mirrors offsetTiers.getLevel()
    ImpactNftClient.prototype.getUpdateCollectionForOffset = function (offset) {
        return __awaiter(this, void 0, void 0, function () {
            var level;
            return __generator(this, function (_a) {
                level = this.getLevelForOffset(offset);
                return [2 /*return*/, (level === null || level === void 0 ? void 0 : level.collectionMint) || null];
            });
        });
    };
    Object.defineProperty(ImpactNftClient.prototype, "levels", {
        get: function () {
            if (!this.tiers)
                throw new Error("Client not initialized");
            var rawLevels = this.tiers.levels;
            // add the index to each level
            return rawLevels.map(function (level, index) { return (__assign(__assign({}, level), { index: index })); });
        },
        enumerable: false,
        configurable: true
    });
    ImpactNftClient.prototype.getCollectionAccounts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var levels, collectionMint, collectionMetadata, collectionMasterEdition;
            return __generator(this, function (_a) {
                if (!this.tiers)
                    throw new Error("Client not initialized");
                levels = this.tiers.levels;
                collectionMint = levels[0].collectionMint;
                collectionMetadata = this.getMetadataAddress(collectionMint);
                collectionMasterEdition = this.getMasterEditionAddress(collectionMint);
                return [2 /*return*/, {
                        collectionMint: collectionMint,
                        collectionMetadata: collectionMetadata,
                        collectionMasterEdition: collectionMasterEdition,
                    }];
            });
        });
    };
    ImpactNftClient.prototype.mintNft = function (mint, mintAuthority, user, initialOffset, principal) {
        return __awaiter(this, void 0, void 0, function () {
            var mintNftAccounts, modifyComputeUnits, accounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMintNftAccounts(mint.publicKey, user)];
                    case 1:
                        mintNftAccounts = _a.sent();
                        modifyComputeUnits = ComputeBudgetProgram.setComputeUnitLimit({
                            units: 300000,
                        });
                        accounts = __assign(__assign({}, mintNftAccounts), { payer: this.provider.publicKey, mint: mint.publicKey, tokenProgram: TOKEN_PROGRAM_ID, mintNftToOwner: user, mintNftTo: mintNftAccounts.userTokenAccount, associatedTokenProgram: ASSOCIATED_TOKEN_PROGRAM_ID, systemProgram: SystemProgram.programId, rent: anchor.web3.SYSVAR_RENT_PUBKEY, globalState: this.stateAddress });
                        return [2 /*return*/, this.program.methods
                                .mintNft(initialOffset, principal)
                                .accounts(accounts)
                                .preInstructions([modifyComputeUnits])
                                .signers([mint, mintAuthority])
                                .rpc()];
                }
            });
        });
    };
    ImpactNftClient.prototype.updateNft = function (mint, mintAuthority, user, updatedOffset) {
        return __awaiter(this, void 0, void 0, function () {
            var accounts, updateAccounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMintNftAccounts(mint.publicKey, user)];
                    case 1:
                        accounts = _a.sent();
                        return [4 /*yield*/, this.getUpdateNftAccounts(mint.publicKey, updatedOffset)];
                    case 2:
                        updateAccounts = _a.sent();
                        return [2 /*return*/, this.program.methods
                                .updateNft(updatedOffset)
                                .accounts(__assign(__assign(__assign({}, accounts), updateAccounts), { globalState: this.stateAddress, mint: mint.publicKey, tokenProgram: TOKEN_PROGRAM_ID }))
                                .signers([mintAuthority])
                                .rpc()];
                }
            });
        });
    };
    return ImpactNftClient;
}());
export { ImpactNftClient };
//# sourceMappingURL=../../src/dist/index.js.map